/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { DocumentsFilter } from 'src/customText/appShell/dataTaggingPage/samplerStore';
import { CustomTextDocumentMetadata } from 'src/customText/core/stores/CustomTextDocumentStore';
import { CustomTextGptPredictionsStore } from 'src/customText/core/stores/CustomTextGptPredictionsStore';

export const isDocumentTagged = (document: CustomTextDocumentMetadata) =>
    Boolean(document.classLabels.length || document.entityLabels.length);

export const isDocumentAutoTagged = (document: CustomTextDocumentMetadata, gptPredictionsStore: CustomTextGptPredictionsStore) =>
    Boolean(document.entityLabels.some(l => l.labelType === 'autoTagged')) ||
    gptPredictionsStore?.documents?.some(d => d.name === document.name);

export const isDocumentFiltered = (
    document: CustomTextDocumentMetadata,
    appliedFilters: DocumentsFilter,
    gptPredictionsStore: CustomTextGptPredictionsStore
) =>
    (appliedFilters.files.includes('tagged') && isDocumentTagged(document)) ||
    (appliedFilters.files.includes('untagged') && !isDocumentTagged(document)) ||
    (appliedFilters.files.includes('autotagged') && isDocumentAutoTagged(document, gptPredictionsStore)) ||
    (appliedFilters.files.includes('testing') && document.documentDataset === 'Test') ||
    (appliedFilters.files.includes('training') && document.documentDataset === 'Train') ||
    appliedFilters.labels.reduce(
        (prev, curr) =>
            Boolean(prev && (document.classLabels.find(c => c.id === curr.id) || document.entityLabels.find(e => e.entityId === curr.id))),
        Boolean(appliedFilters.labels.length)
    );
